import React from "react";
import Newsroom from "../component/Newsroom";

function NewsroomContainer({ mediaData }) {
  return <Newsroom mediaData={mediaData} />;
}
export default NewsroomContainer;
